import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

// import moment from 'moment';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core';
import withMobileDialog from '@material-ui/core/withMobileDialog/withMobileDialog';
import DialogContent from '@material-ui/core/DialogContent';

import FMPText from './pureForm/FMPText';
import Transition from './Dialogs/Transition';
import FormComponent from './FormComponent';
import Note from './ui/Note';

const styles = (theme) => ({
	dialogPadding: {
		padding: 10,
		[theme.breakpoints.up('md')]: {
			padding: '20px 50px 20px 50px',
		},
	},
	dialogPaper: {
		overflow: 'scroll',
		maxWidth: '100%',
		width: 800,
		//maxWidth: '98%',
		maxHeight: 'calc(100% - 20px)',
		margin: 10,
	},
	label: {
		paddingRight: 5,
	},
	value: {
		fontWeight: 600,
	},
	new: {
		marginTop: 20,
	},
	current: {
		marginBottom: 15,
	},
	addInputButton: {
		borderRadius: '100px',
	},
});

class AddGmAdderDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			volume: '',
		};
	}

	handleRequestClose = () => {
		this.props.onClose();
	};

	handleAddUpdate = () => {
		const { showErrors, gmAdderChangeAdd } = this.props;

		if (!this.state.newValue) {
			this.setState({ formFieldError: { newValue: 'New value is required' } });
			return showErrors(['New value is required']);
		}
		const newValue = parseFloat(this.state.newValue);

		if (!_.isNumber(newValue) || _.isNaN(newValue)) {
			return showErrors(['New value required as a decimal']);
		}

		if (!this.state.message) {
			this.setState({ formFieldError: { message: 'Note is required' } });
			return showErrors(['Note required']);
		}

		const params = {
			newValue,
			message: this.state.message,
		};

		gmAdderChangeAdd({
			params,
			callback: function (err) {
				if (err) {
					showErrors(err);
				}
				this.props.onClose();
			}.bind(this),
		});
	};

	render() {
		const { classes } = this.props;

		return (
			<Dialog
				classes={{ paper: classes.dialogPaper }}
				maxWidth="md"
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleRequestClose}
			>
				<div className={classes.dialogPadding}>
					<DialogTitle>
						<span>Add New PLC</span>
					</DialogTitle>

					<DialogContent style={{ fontSize: 18 }}>
						<FMPText
							{...this.setForm(`newValue`, 'New Price', true)}
							helpText={'Decimal format (eg 0.375)'}
						/>
						<FMPText {...this.setForm(`message`, 'Note', true)} />

						<Note>
							This will create a record of this update and this value will be used going forward
							across all formulas that include the PearsonFuels Logistics Cost (PLC)
						</Note>
					</DialogContent>
					<DialogActions>
						<Button onClick={this.handleRequestClose}>Cancel</Button>
						<Button
							variant="contained"
							onClick={this.handleAddUpdate}
							color="primary"
							className={classes.addInputButton}
						>
							{'Add'}
						</Button>
					</DialogActions>
				</div>
			</Dialog>
		);
	}
}

AddGmAdderDialog.propTypes = {
	open: PropTypes.bool,
	gmAdderChangeAdd: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(AddGmAdderDialog);
